import {
    FETCH_PORTFOLIO,
    FETCH_PORTFOLIO_SUCCESS,
    FETCH_PORTFOLIO_FAIL,
    FETCH_CYCLE_REPORT,
    FETCH_CYCLE_REPORT_SUCCESS,
    FETCH_CYCLE_REPORT_FAIL,
    FETCH_CYCLE_DETAILS,
    FETCH_CYCLE_DETAILS_SUCCESS,
    FETCH_CYCLE_DETAILS_FAIL,
    FETCH_BR_BUSINESS_SHARES,
    FETCH_BR_BUSINESS_SHARES_SUCCESS,
    FETCH_BR_BUSINESS_SHARES_FAIL,
    ADD_BR_BUSINESS_SHARE,
    ADD_BR_BUSINESS_SHARE_SUCCESS,
    ADD_BR_BUSINESS_SHARE_FAIL,
    UPDATE_BR_BUSINESS_SHARE,
    UPDATE_BR_BUSINESS_SHARE_SUCCESS,
    UPDATE_BR_BUSINESS_SHARE_FAIL,
    SET_ENTITY_IN_VIEW,
    BREACHRISK_REINIT_STATE,
    ADD_BR_PORTFOLIO_ENTITY,
    ADD_BR_PORTFOLIO_ENTITY_SUCCESS,
    ADD_BR_PORTFOLIO_ENTITY_FAIL,
    DELETE_BR_PORTFOLIO_ENTITY,
    DELETE_BR_PORTFOLIO_ENTITY_SUCCESS,
    DELETE_BR_PORTFOLIO_ENTITY_FAIL,
    ADD_BR_PORTFOLIO_REPORT_REQUEST,
    ADD_BR_PORTFOLIO_REPORT_REQUEST_FAIL,
    ADD_BR_PORTFOLIO_REPORT_REQUEST_SUCCESS,
    UPDATE_BR_ATTACKS_AUTHORIZED,
    UPDATE_BR_ATTACKS_AUTHORIZED_SUCCESS,
    UPDATE_BR_ATTACKS_AUTHORIZED_FAIL,
    ADD_BR_TARGETIP_PROVIDED,
    ADD_BR_TARGETIP_PROVIDED_SUCCESS,
    ADD_BR_TARGETIP_PROVIDED_FAIL,
    UPDATE_BR_TARGETIP_PROVIDED,
    UPDATE_BR_TARGETIP_PROVIDED_SUCCESS,
    UPDATE_BR_TARGETIP_PROVIDED_FAIL,
    UPDATE_BR_DOMAIN_PROVIDED_FAIL,
    UPDATE_BR_DOMAIN_PROVIDED_SUCCESS,
    UPDATE_BR_DOMAIN_PROVIDED,
    ADD_BR_DOMAIN_PROVIDED_FAIL,
    ADD_BR_DOMAIN_PROVIDED_SUCCESS,
    ADD_BR_DOMAIN_PROVIDED,
    ADD_BR_SUBDOMAIN_PROVIDED_FAIL,
    ADD_BR_SUBDOMAIN_PROVIDED,
    UPDATE_BR_SUBDOMAIN_PROVIDED,
    UPDATE_BR_SUBDOMAIN_PROVIDED_SUCCESS,
    UPDATE_BR_SUBDOMAIN_PROVIDED_FAIL,
    ADD_BR_SUBDOMAIN_PROVIDED_SUCCESS,
    ADD_BR_VALIDATION,
    ADD_BR_VALIDATION_SUCCESS,
    ADD_BR_VALIDATION_FAIL,
    FETCH_CYCLE_TARGETS,
    FETCH_CYCLE_TARGETS_SUCCESS,
    FETCH_CYCLE_TARGETS_FAIL,
    FETCH_CYCLE,
    FETCH_CYCLE_SUCCESS,
    FETCH_CYCLE_FAIL,
    ADD_TAG_SUCCESS_TESTED_VECTORS,
    ADD_TAG_FAIL_TESTED_VECTORS,
    UPDATE_TAG_SUCCESS_TESTED_VECTORS,
    UPDATE_TAG_FAIL_TESTED_VECTORS,
    CLOUD_INTEGRATION_GET_OPTIONS,
    CLOUD_INTEGRATION_GET_OPTIONS_SUCCESS,
    CLOUD_INTEGRATION_GET_OPTIONS_FAIL,
    CLOUD_INTEGRATION_REGISTER,
    CLOUD_INTEGRATION_REGISTER_SUCCESS,
    CLOUD_INTEGRATION_REGISTER_FAIL,
    CLOUD_INTEGRATION_UNREGISTER,
    CLOUD_INTEGRATION_UNREGISTER_SUCCESS,
    CLOUD_INTEGRATION_UNREGISTER_FAIL,
    FETCH_TARGET_DETAILS,
    FETCH_TARGET_DETAILS_SUCCESS,
    FETCH_TARGET_DETAILS_FAIL,
    FETCH_CYCLE_SOCIAL,
    FETCH_CYCLE_SOCIAL_SUCCESS,
    FETCH_CYCLE_SOCIAL_FAIL,
    FETCH_IDENTITY_DETAILS,
    FETCH_IDENTITY_DETAILS_SUCCESS,
    FETCH_IDENTITY_DETAILS_FAIL,
    UPDATE_BR_SOCIAL_TESTS_AUTHORIZED,
    UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_SUCCESS,
    UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_FAIL,
    ADD_TAG_IDENTITY_SUCCESS,
    ADD_TAG_IDENTITY_FAIL,
    UPDATE_TAG_IDENTITY_SUCCESS,
    UPDATE_TAG_IDENTITY_FAIL,
    ADD_BR_IDENTITY_PROVIDED,
    ADD_BR_IDENTITY_PROVIDED_SUCCESS,
    ADD_BR_IDENTITY_PROVIDED_FAIL,
    UPDATE_BR_IDENTITY_PROVIDED,
    UPDATE_BR_IDENTITY_PROVIDED_SUCCESS,
    UPDATE_BR_IDENTITY_PROVIDED_FAIL,
    ADD_TAG_ENTITY_SUCCESS,
    ADD_TAG_ENTITY_FAIL,
    UPDATE_TAG_ENTITY_SUCCESS,
    UPDATE_TAG_ENTITY_FAIL,
    SET_UPDATE_ENTITY_ONBOARDING_PROGRESS,
    UNSET_UPDATE_ENTITY_ONBAORDING_PROGRESS,
    FETCH_CLOUD_INTEGRATION_DATA,
    FETCH_CLOUD_INTEGRATION_DATA_SUCCESS,
    FETCH_CLOUD_INTEGRATION_DATA_FAIL,
    FETCH_VECTOR_RESULTS,
    FETCH_VECTOR_RESULTS_SUCCESS,
    FETCH_VECTOR_RESULTS_FAIL,
    ADD_BR_SUB_PORTFOLIO,
    ADD_BR_SUB_PORTFOLIO_SUCCESS,
    ADD_BR_SUB_PORTFOLIO_FAIL,
    ADD_BR_SUBPORTFOLIO,
    ADD_BR_SUBPORTFOLIO_SUCCESS,
    ADD_BR_SUBPORTFOLIO_FAIL,
    DELETE_BR_SUBPORTFOLIO,
    DELETE_BR_SUBPORTFOLIO_SUCCESS,
    DELETE_BR_SUBPORTFOLIO_FAIL,
    ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO,
    ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO_SUCCESS,
    ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO_FAIL,
    ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO_SUCCESS,
    ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO_FAIL,
    DELETE_BR_ENTITY_FROM_SUBPORTFOLIO_SUCCESS,
    DELETE_BR_ENTITY_FROM_SUBPORTFOLIO_FAIL,
    UPDATE_BR_SUBPORTFOLIO,
    UPDATE_BR_SUBPORTFOLIO_SUCCESS,
    UPDATE_BR_SUBPORTFOLIO_FAIL,
    SET_SUBPORTFOLIO_IN_VIEW,
    FETCH_CLOUD_INTEGRATION_FILES,
    FETCH_CLOUD_INTEGRATION_FILES_SUCCESS,
    FETCH_CLOUD_INTEGRATION_FILES_FAIL,
    VERIFY_PRIMARY_DOMAIN,
    VERIFY_PRIMARY_DOMAIN_SUCCESS,
    VERIFY_PRIMARY_DOMAIN_FAIL,
    UPDATE_ENTITY_NAME,
    UPDATE_ENTITY_NAME_SUCCESS,
    UPDATE_ENTITY_NAME_FAIL
} from 'constants/ActionTypes';
import {bbDangerousStringToDate, bbIsObject} from "../util/bbHelpers";
import {addTag, updateTag} from "./Common";

/* ****************
Similar to setting the customer in view, to retain the customer in view functionality
and since entities are associated with customers, this allows
for partners to see multiple customers and then have the BRP interface
show a different entity in the sidebar
 *******************/
export const setEntityInView = (entityId) => {
    return {
        type: SET_ENTITY_IN_VIEW,
        payload: entityId
    };
};

// jfd********** `--===<>==<>==C>-<
/**
 * Summary. Update the state with the subportfolioId in view
 *
 * Description. (use period)
 *
 * @param {string}   subportfolioId           Id of the subportfolio that will now be in view
 *
 * @return {type} Return value description.
 */
    //*****************************************
export const setSubportfolioInView = (subportfolioId) => {
    return {
        type: SET_SUBPORTFOLIO_IN_VIEW,
        payload: subportfolioId
    };
};

export const reinitBreachRiskState = () => {
    console.log("Reinitializing BreachRisk™ State");
    return {
        type: BREACHRISK_REINIT_STATE
    };
};

/* ****************
Fetching risk portfolio
 *******************/
export const fetchRiskPortfolio = (data) => {
    return {
        type: FETCH_PORTFOLIO,
        payload: data,
    };
};

export const fetchRiskPortfolioSuccess = (data) => {
    return {
        type: FETCH_PORTFOLIO_SUCCESS,
        payload: data
    };
};

export const fetchRiskPortfolioFail = (data) => {
    return {
        type: FETCH_PORTFOLIO_FAIL,
        payload: data
    };
};


/* ****************
Fetching risk cycle reports
 *******************/

//TODO: Sarah, use this function to create another function like we did with updateBRSubscriptionEndDate to make a JDOC and foolproof function
// that will fetch the report data for a given cycleId/customerId
export const fetchRiskCycleReport = (data) => {
    return {
        type: FETCH_CYCLE_REPORT,
        payload: data
    };
};
/**
 * Summary. fetchRiskCycleReport
 *
 * Description. Dispatch this to call cycle report for a given cycle Id (embeds in entity's cycles object)
 *
 * @param {number}   customerId      the customer id of the customer/client company that cycle belongs to
 * @param {number}   cycleId         cycleId for the cycle report being called
 *
 * @return
 *
 * @example         dispatch(fetchRiskCycleReportSafe(customer123, cycle456)) //adds cycle456 to the cycles object in the portfolio for customer123
 */

export const fetchRiskCycleReportSafe = (customerId, cycleId)=> {
    return fetchRiskCycleReport(customerId, cycleId)
}

export const fetchRiskCycleReportSuccess = (data) => {
    return {
        type: FETCH_CYCLE_REPORT_SUCCESS,
        payload: data
    };
};

export const fetchRiskCycleReportFail = (data) => {
    return {
        type: FETCH_CYCLE_REPORT_FAIL,
        payload: data
    };
};

/* ****************
Fetching risk cycle details (tech data)
 *******************/
const fetchRiskCycleDetails = (data) => {
    return {
        type: FETCH_CYCLE_DETAILS,
        payload: data
    };
};

export const fetchRiskCycleDetailsSuccess = (data) => {
    return {
        type: FETCH_CYCLE_DETAILS_SUCCESS,
        payload: data
    };
};

export const fetchRiskCycleDetailsFail = (data) => {
    return {
        type: FETCH_CYCLE_DETAILS_FAIL,
        payload: data
    };
};

/* ****************
Risk Cycle Details helper: requesting by page
 *******************/

/**
 * Summary. fetchRiskCycleDetailsPagewise.
 *
 * Description. fetches a risk cycle details (tech data) for the given page
 *
 *  @param {number}   cycleId             The Id of the cycle for which details
 *   @param {number}   customerId             The Id of the entity
 * @param {number}   pageNum             The page number to fetch.
 *
 * @return
 *
 * @example
 */
export const fetchRiskCycleDetailsPagewise = (cycleId, customerId,pageNum= 1, ) => {

    const payload = {
        cycleId,
        customerId,
        pageNum,
    };

    return fetchRiskCycleDetails(payload);

};

/* ****************
Fetching target details
 *******************/
export const fetchTargetDetails = (data) => {
    return {
        type: FETCH_TARGET_DETAILS,
        payload: data
    };
};

export const fetchTargetDetailsSuccess = (data) => {
    return {
        type: FETCH_TARGET_DETAILS_SUCCESS,
        payload: data
    };
};

export const fetchTargetDetailsFail = (data) => {
    return {
        type: FETCH_TARGET_DETAILS_FAIL,
        payload: data
    };
};

/* ****************
Fetching shares for a BR Business Entity
 *******************/
export const fetchBRBusinessShares = (data) => {
    return {
        type: FETCH_BR_BUSINESS_SHARES,
        payload: data
    };
};

export const fetchBRBusinessSharesSuccess = (data) => {
    return {
        type: FETCH_BR_BUSINESS_SHARES_SUCCESS,
        payload: data
    };
};

export const fetchBRBusinessSharesFail = (data) => {
    return {
        type: FETCH_BR_BUSINESS_SHARES_FAIL,
        payload: data
    };
};

/* ****************
Adding shares for a BR Business Entity
 *******************/
export const addBRBusinessShare = (data) => {
    return {
        type: ADD_BR_BUSINESS_SHARE,
        payload: data
    };
};

export const addBRBusinessShareSuccess = (data) => {
    return {
        type: ADD_BR_BUSINESS_SHARE_SUCCESS,
        payload: data
    };
};

export const addBRBusinessShareFail = (data) => {
    return {
        type: ADD_BR_BUSINESS_SHARE_FAIL,
        payload: data
    };
};

/* ****************
Deleting shares for a BR Business Entity
 *******************/
export const updateBRBusinessShare = (customerId, shareId, shareProperty, newStatus, newLevel) => {
    console.log("This is updateBRBUsinessSHare which our first action calls, here's the data, customerId", customerId, "shareId'", shareId, "SHareProperty", shareProperty, "newStatus", newStatus, "newLevel", newLevel)
    return {
        type: UPDATE_BR_BUSINESS_SHARE,
        payload: {
            customerId,
            shareId,
            property: shareProperty,
            newStatus,
            newLevel
        }
    };
};

export const disableBRBusinessShare = (data) => {
    return {
        type: UPDATE_BR_BUSINESS_SHARE,
        payload: {
            ...data,
            newActiveStatus: false
        }
    };
};

export const enableBRBusinessShare = (data) => {
    return {
        type: UPDATE_BR_BUSINESS_SHARE,
        payload: {
            ...data,
            newActiveStatus: true
        }
    };
};

export const updateBRBusinessShareSuccess = (data) => {
    return {
        type: UPDATE_BR_BUSINESS_SHARE_SUCCESS,
        payload: data
    };
};

export const updateBRBusinessShareFail = (data) => {
    return {
        type: UPDATE_BR_BUSINESS_SHARE_FAIL,
        payload: data
    };
};

/* ****************
Updating Access Level for a Business Share
 *******************/

export const updateBRBusinessShareAccessLevel = (customerId, shareId, newLevel)=>{
    console.log("This is the data passed to the action from the dispatch in the component", "customerId", customerId, "shareId", shareId, "newLevel", newLevel)
    return updateBRBusinessShare(customerId, shareId, "data_level", null, newLevel)
}
/* ****************
Adding organizations to a Portfolio
 *******************/
export const addBRPortfolioEntity = (data) => {
    return {
        type: ADD_BR_PORTFOLIO_ENTITY,
        payload: data
    };
};

export const addBRPortfolioEntitySuccess = (data) => {
    return {
        type: ADD_BR_PORTFOLIO_ENTITY_SUCCESS,
        payload: data
    };
};

export const addBRPortfolioEntityFail = (data) => {
    return {
        type: ADD_BR_PORTFOLIO_ENTITY_FAIL,
        payload: data
    };
};

/* ****************
Deleting organizations to a Portfolio
 *******************/
export const deleteBRPortfolioEntity = (data) => {
    return {
        type: DELETE_BR_PORTFOLIO_ENTITY,
        payload: data
    };
};

export const deleteBRPortfolioEntitySuccess = (data) => {
    return {
        type: DELETE_BR_PORTFOLIO_ENTITY_SUCCESS,
        payload: data
    };
};

export const deleteBRPortfolioEntityFail = (data) => {
    return {
        type: DELETE_BR_PORTFOLIO_ENTITY_FAIL,
        payload: data
    };
};

/* ****************
Adding a BR Report Request share. Allows BRP to see the BR Report of a BRfB
 *******************/
export const addBRPortfolioReportRequest = (data) => {
    console.log("AddBRPortfolioReportrequest action dispathc data is", data);
    return {
        type: ADD_BR_PORTFOLIO_REPORT_REQUEST,
        payload: data
    };
};

export const addBRPortfolioReportRequestSuccess = (data) => {
    return {
        type: ADD_BR_PORTFOLIO_REPORT_REQUEST_SUCCESS,
        payload: data
    };
};

export const addBRPortfolioReportRequestFail = (data) => {
    return {
        type: ADD_BR_PORTFOLIO_REPORT_REQUEST_FAIL,
        payload: data
    };
};

/* ****************
Updating attacks authorized status for BR Business. Enables or disables active attack testing methods.
 *******************/
export const updateBRAttacksAuthorized = (data) => {
    return {
        type: UPDATE_BR_ATTACKS_AUTHORIZED,
        payload: data
    };
};

export const disableBRAttacksAuthorized = (data) => {
    return {
        type: UPDATE_BR_ATTACKS_AUTHORIZED,
        payload: {
            ...data,
            newAuthorizeStatus: false
        }
    };
};

export const enableBRAttacksAuthorized = (data) => {
    return {
        type: UPDATE_BR_ATTACKS_AUTHORIZED,
        payload: {
            ...data,
            newAuthorizeStatus: true
        }
    };
};

export const updateBRAttacksAuthorizedSuccess = (data) => {
    return {
        type: UPDATE_BR_ATTACKS_AUTHORIZED_SUCCESS,
        payload: data
    };
};

export const updateBRAttacksAuthorizedFail = (data) => {
    return {
        type: UPDATE_BR_ATTACKS_AUTHORIZED_FAIL,
        payload: data
    };
};

/* ****************
Adding a Target Provided
 *******************/
export const addBRTargetIpProvided = (data) => {
    return {
        type: ADD_BR_TARGETIP_PROVIDED,
        payload: data
    };
};

export const addBRTargetIpProvidedSuccess = (data) => {
    return {
        type: ADD_BR_TARGETIP_PROVIDED_SUCCESS,
        payload: data
    };
};

export const addBRTargetIpProvidedFail = (data) => {
    return {
        type: ADD_BR_TARGETIP_PROVIDED_FAIL,
        payload: data
    };
};

/* ****************
Deleting (updating) Target IPs
 *******************/
export const updateBRTargetIpProvided = (data) => {
    return {
        type: UPDATE_BR_TARGETIP_PROVIDED,
        payload: data
    };
};

export const updateBRTargetIpProvidedSuccess = (data) => {
    return {
        type: UPDATE_BR_TARGETIP_PROVIDED_SUCCESS,
        payload: data
    };
};

export const updateBRTargetIpProvidedFail = (data) => {
    return {
        type: UPDATE_BR_TARGETIP_PROVIDED_FAIL,
        payload: data
    };
};

/* ****************
Adding a DOMAIN Provided
 *******************/
export const addBRDomainProvided = (data) => {
    return {
        type: ADD_BR_DOMAIN_PROVIDED,
        payload: data
    };
};

export const addBRDomainProvidedSuccess = (data) => {
    return {
        type: ADD_BR_DOMAIN_PROVIDED_SUCCESS,
        payload: data
    };
};

export const addBRDomainProvidedFail = (data) => {
    return {
        type: ADD_BR_DOMAIN_PROVIDED_FAIL,
        payload: data
    };
};

/* ****************
Deleting (updating) Domains
 *******************/
export const updateBRDomainProvided = (data) => {
    return {
        type: UPDATE_BR_DOMAIN_PROVIDED,
        payload: data
    };
};

export const updateBRDomainProvidedSuccess = (data) => {
    return {
        type: UPDATE_BR_DOMAIN_PROVIDED_SUCCESS,
        payload: data
    };
};

export const updateBRDomainProvidedFail = (data) => {
    return {
        type: UPDATE_BR_DOMAIN_PROVIDED_FAIL,
        payload: data
    };
};

/* ****************
Adding a subDOMAIN Provided
 *******************/
export const addBRSubdomainProvided = (data) => {
    return {
        type: ADD_BR_SUBDOMAIN_PROVIDED,
        payload: data
    };
};

export const addBRSubdomainProvidedSuccess = (data) => {
    return {
        type: ADD_BR_SUBDOMAIN_PROVIDED_SUCCESS,
        payload: data
    };
};

export const addBRSubdomainProvidedFail = (data) => {
    return {
        type: ADD_BR_SUBDOMAIN_PROVIDED_FAIL,
        payload: data
    };
};

/* ****************
Deleting (updating) SUBSUBDOMAIN provided
 *******************/
export const updateBRSubdomainProvided = (data) => {
    return {
        type: UPDATE_BR_SUBDOMAIN_PROVIDED,
        payload: data
    };
};

export const updateBRSubdomainProvidedSuccess = (data) => {
    return {
        type: UPDATE_BR_SUBDOMAIN_PROVIDED_SUCCESS,
        payload: data
    };
};

export const updateBRSubdomainProvidedFail = (data) => {
    return {
        type: UPDATE_BR_SUBDOMAIN_PROVIDED_FAIL,
        payload: data
    };
};

/* ****************
Adding an Identity Provided
 *******************/
export const addBRIdentityProvided = (data) => {
    return {
        type: ADD_BR_IDENTITY_PROVIDED,
        payload: data
    };
};

export const addBRIdentityProvidedSuccess = (data) => {
    return {
        type: ADD_BR_IDENTITY_PROVIDED_SUCCESS,
        payload: data
    };
};

export const addBRIdentityProvidedFail = (data) => {
    return {
        type: ADD_BR_IDENTITY_PROVIDED_FAIL,
        payload: data
    };
};

/* ****************
Deleting (updating) Identity Provided
 *******************/
export const updateBRIdentityProvided = (data) => {
    return {
        type: UPDATE_BR_IDENTITY_PROVIDED,
        payload: data
    };
};

export const updateBRIdentityProvidedSuccess = (data) => {
    return {
        type: UPDATE_BR_IDENTITY_PROVIDED_SUCCESS,
        payload: data
    };
};

export const updateBRIdentityProvidedFail = (data) => {
    return {
        type: UPDATE_BR_IDENTITY_PROVIDED_FAIL,
        payload: data
    };
};

/* ****************
Adding a VALIDATION 
 *******************/
export const addBRValidation = (data) => {
    return {
        type: ADD_BR_VALIDATION,
        payload: data
    };
};

export const addBRValidationSuccess = (data) => {
    return {
        type: ADD_BR_VALIDATION_SUCCESS,
        payload: data
    };
};

export const addBRValidationFail = (data) => {
    return {
        type: ADD_BR_VALIDATION_FAIL,
        payload: data
    };
};


/* ****************
Fetching risk cycle targets (IPs)
 *******************/
export const fetchRiskCycleTargets = (data) => {
    return {
        type: FETCH_CYCLE_TARGETS,
        payload: data
    };
};

export const fetchRiskCycleTargetsSuccess = (data) => {
    return {
        type: FETCH_CYCLE_TARGETS_SUCCESS,
        payload: data
    };
};

export const fetchRiskCycleTargetsFail = (data) => {
    return {
        type: FETCH_CYCLE_TARGETS_FAIL,
        payload: data
    };
};


/* ****************
Fetching risk cycles so we can show past reports and past cycle details
 *******************/
export const fetchRiskCycle = (data) => {
    return {
        type: FETCH_CYCLE,
        payload: data
    };
};

export const fetchRiskCycleSuccess = (data) => {
    return {
        type: FETCH_CYCLE_SUCCESS,
        payload: data
    };
};

export const fetchRiskCycleFail = (data) => {
    return {
        type: FETCH_CYCLE_FAIL,
        payload: data
    };
};

/*  jfd**********22.Jan.24.12:44*****
 *   BREACHRISK TAGS
     ********************** `--===<>==<>==C>-< */

//For tech data page updating scope, comments, issue status, etc
const addTagSuccessTestedVectors = (data) => {
    return {
        type: ADD_TAG_SUCCESS_TESTED_VECTORS,
        payload: data
    };
};

const addTagFailTestedVectors = (data) => {
    return {
        type: ADD_TAG_FAIL_TESTED_VECTORS,
        payload: data
    };
};

/* ****************
Tag helper: Set out of Scope
 *******************/
/**
 * Summary. tagVectorOutOfScope.
 *
 * Description. Adds an 'Out of Scope' tag to the given vector.
 *
 * @param {number}   customerId             The Id of the customer associated with the entity
 *  @param {string}   entityId             The Id of the entity
 * @param {string}   vectorId             The Id of the vector to be tagged (not the tested_vector_id)
 * @param {string}   testedVectorId             The persistent id of the vector
 *
 * @return
 *
 * @example
 */
export const tagVectorOutOfScope = ( customerId, entityId, vectorId,testedVectorId) => {
    //for Out Of Scope type, the definitionId is 38 as of Nov 2021
    return addTag(
        addTagSuccessTestedVectors, //successAction
        addTagFailTestedVectors, //failAction
        38, //definitionId
        entityId, //entityId
        null, //targetId
        null, //vectorId
        testedVectorId, //testedVectorId
        null, //identityid
        null, //details
        null, //userId
        customerId, //customerId,
        null, //subportfolioId
        true, //showUserMessage
        vectorId, //affectedElementId
    );
};

/* ****************
Tag helper: Set a vector back in scope
 *******************/
/**
 * Summary. tagVectorInScope.
 *
 * Description. Sets a vector back in scope by removing the Out of Scope.
 *
 *  @param {number}   customerId             The Id of the customer
 *  @param {number}   vectorId             The Id of the vector to be tagged (not the tested_vector_id)
 * @param {object}   tag             The tag that should be set to inactive.
 *
 * @return
 *
 * @example
 */
export const tagVectorInScope = (customerId, vectorId, tag) => {
    //TODO: consider looking for any tag that is set to active that is on this vector.

    console.log("Helper function about to tagVectorInScope", customerId, vectorId, tag);

    if(bbIsObject(tag) && tag.definition.id === 38) {
        //TODO: verify that the tag is of type 38
        //for Out Of Scope type, the definitionId is 38 as of Nov 2021
        return updateTag(
            updateTagSuccessTestedVectors,
            updateTagFailTestedVectors,
            tag.id,
            false,
            customerId,
            vectorId);
    } else {
        return updateTagFailTestedVectors({
            customerId,
            vectorId,
            tagId: tag.id
        })
    }

};

/* ****************
Tag helper: Commenting on a vector
 *******************/
/**
 * Summary. tagVectorCommentAdd.
 *
 * Description. Adds an 'comment' tag to the given vector.
 *
 *  @param {number}   customerId             The Id of the customer
 * @param {number}   entityId             The Id of the entity
 * @param {number}   vectorId             The Id of the vector to be tagged (not the tested_vector_id)
 * @param {number}   testedVectorId             The persistent id of the vector
 * @param {string}   commentText             String of text for the comment.
 *
 * @return
 *
 * @example
 */
export const tagVectorCommentAdd = (customerId, entityId, vectorId, testedVectorId, commentText) => {
    //for comment type, the definitionId is 43 as of Nov 2021
    /*  jfd**********22.Jan.24.11:03*****
     *   Upgrading tag functions
         ********************** `--===<>==<>==C>-< */
    // return addTag( customerId, entityId, vectorId,43, testedVectorId, commentText);
    return addTag(
        addTagSuccessTestedVectors, //successAction
        addTagFailTestedVectors, //failAction
        43, //definitionId
        entityId, //entityId
        null, //targetId
        null, //vectorId
        testedVectorId, //testedVectorId
        null, //identityid
        commentText, //details
        null, //userId
        customerId, //customerId
        null, //subportfolioId
        true, //showUserMessage
        vectorId, //affectedElementId
    );
};

/* ****************
Tag helper: Remove a comment from a vector
 *******************/
/**
 * Summary. tagVectorCommentDelete.
 *
 * Description. Sets a vector back in scope by removing the Out of Scope.
 *  @param {number}   customerId             The Id of the customer
 * @param {object}   tag             The tag that should be set to inactive.
 *
 * @return
 *
 * @example
 */
export const tagVectorCommentDelete = ( customerId, tag) => {
    //TODO: consider looking for any tag that is set to active that is on this vector.

    if(bbIsObject(tag) && tag.id === 43) {
        //for comment, the definitionId is 43 as of Nov 2021
        return updateTag(
            updateTagSuccessTestedVectors,
            updateTagFailTestedVectors,
            tag.id,
            false,
            customerId);
    } else {
        return updateTagFailTestedVectors({
            customerId: customerId,
            tagId: tag.id
        })
    }

};

/* ****************
Tag helper: Adding client status tag
 *******************/
/**
 * Summary. tagVectorClientStatusAdd.
 *
 * Description. Adds a 'status' tag to the given vector. The type of tag is a number, stored in the tag details, corresponds to bbDictionaryOfClientStatusTags object
 *
 *  @param {number}   customerId             The Id of the customer
 * @param {string}   entityId             The Id of the entity
 * @param {string}   vectorId             The Id of the vector to be tagged (not the tested_vector_id)
 * @param {string}   testedVectorId             The persistent id of the vector
 *@param {string}   statusId            the id of the client status
 * @param {boolean} showUserMessage     whether or not to have the user message visible upon completion
 * @return
 *
 * @example
 */
export const tagVectorClientStatusAdd = (customerId, entityId, vectorId, testedVectorId, statusId, showUserMessage =true) => {
    //for status type, the definitionId is 44 as of Dec 2021

    /*  jfd**********22.Jan.24.10:57*****
     *   Upgrading the tag functions
         ********************** `--===<>==<>==C>-< */
    // return addTag( customerId, entityId, vectorId,44, testedVectorId, statusId, showUserMessage);
    return addTag(
        addTagSuccessTestedVectors, //successAction
        addTagFailTestedVectors, //failAction
        44, //definitionId
        entityId, //entityId
        null, //targetId
        null, //vectorId
        testedVectorId, //testedVectorId
        null, //identityid
        statusId, //details
        null, //userId
        customerId, //customerId
        null, //subportfolioId
        showUserMessage, //showUserMessage
        vectorId, //affectedElementId
    );
};

/* ****************
Tag helper: Updating client status tag
 *******************/

/**
 * Summary. tagVectorClientStatusUpdate.
 *
 * Description. Sets a vector back in scope by removing the Out of Scope.
 *
 *  @param {number}   customerId             The Id of the customer
 *   @param {string}   entityId             The Id of the entity
 *  @param {string}   vectorId             The Id of the vector to be tagged (not the tested_vector_id)
 *   @param {string}   testedVectorId             The persistent id of the vector
 * @param {object}   tag             The tag that should be set to inactive.
 *
 * @return
 *
 * @example
 */
export const tagVectorClientStatusUpdate = (customerId,entityId, vectorId, testedVectorId, tag) => {

    if(bbIsObject(tag) && tag.definition.id === 44) {
        //TODO: verify that the tag is of type 44
        return updateTag(
            updateTagSuccessTestedVectors,
            updateTagFailTestedVectors,
            tag.id,
            false,
            customerId,
            vectorId);
    } else {
        return updateTagFailTestedVectors({
            customerId,
            vectorId,
            tagId: tag.id
        })
    }

};

export const updateTagSuccessTestedVectors = (data) => {
    return {
        type: UPDATE_TAG_SUCCESS_TESTED_VECTORS,
        payload: data
    };
};

export const updateTagFailTestedVectors = (data) => {
    return {
        type: UPDATE_TAG_FAIL_TESTED_VECTORS,
        payload: data
    };
};


/* ****************
CLOUD INTEGRATIONS
 *******************/
/**
 * Summary. fetchCloudIntegrationOptions
 *
 * Description. Gets a list of the cloud integration options available for the given entity.
 *
 * @param {string}   entityId      The entity to fetch options for
 *
 * @return
 *
 * @example
 */
export const fetchCloudIntegrationOptions = (entityId) => {
    return {
        type: CLOUD_INTEGRATION_GET_OPTIONS,
        payload: {
            entityId
        }
    };
};

export const fetchCloudIntegrationOptionsSuccess = (data) => {
    return {
        type: CLOUD_INTEGRATION_GET_OPTIONS_SUCCESS,
        payload: data
    };
};

export const fetchCloudIntegrationOptionsFail = (data) => {
    return {
        type: CLOUD_INTEGRATION_GET_OPTIONS_FAIL,
        payload: data
    };
};

/**
 * Summary. registerCloudIntegration
 *
 * Description. Sends the integration registration request to start the cloud integration process.
 *
 * @param {string}   entityId      The entity to get options for
 * @param {number}   typeId        The typeId corresponding to AWS, DO, etc technology provider
 * @param {string}   description      User-optional description
 * @param {string}   roleArn      (For AWS Only) ARN for AWS
 *
 * @return
 *
 * @example
 */
const registerCloudIntegration = (entityId, typeId, description = null, roleArn = null, tenentId = null, appId = null, clientSecret = null) => {
    return {
        type: CLOUD_INTEGRATION_REGISTER,
        payload: {
            entityId,
            typeId,
            description,
            roleArn,//aws
            tenentId,//azure
            appId,//azure
            clientSecret,//azure
        }
    };
};

export const registerCloudIntegrationSuccess = (data) => {
    return {
        type: CLOUD_INTEGRATION_REGISTER_SUCCESS,
        payload: data
    };
};

export const registerCloudIntegrationFail = (data) => {
    return {
        type: CLOUD_INTEGRATION_REGISTER_FAIL,
        payload: data
    };
};

/* ****************
Cloud Integration helper: Choosing the correct technology (AWS, DO, etc)
 *******************/
/**
 * Summary. registerCloudIntegrationAzure
 *
 * Description.
 *
 * @param entityId
 * @param description(optional)
 * @param tenentId(required)
 * @param appId(required)
 * @param clientSecret(required)
 * @returns {{payload: {roleArn: string, description: string, entityId: string, typeId: number}, type: string}}
 */
export const registerCloudIntegrationAzure = (entityId, description = null, tenentId, appId, clientSecret )=>{
    return registerCloudIntegration(
        entityId,
        3, //typeId for Azure,
        description,
        null, //no ARN for Azure,
        tenentId,
        appId,
        clientSecret
    );
}


/**
 * Summary. registerCloudIntegrationDigitalOcean
 *
 * Description. Sends the integration registration request to start the Digital Ocean cloud integration process.
 *
 * @param {string}   entityId      The entity to get options for
 * @param {string}   description      User-optional description
 *
 * @return
 *
 * @example
 */
export const registerCloudIntegrationDigitalOcean = (entityId, description = null) => {
    return registerCloudIntegration(
        entityId,
        1, //typeId
        description
        );
};

/**
 * Summary. registerCloudIntegrationAWS
 *
 * Description. Sends the integration registration request to start the AWS cloud integration process.
 *
 * @param {string}   entityId      The entity to get options for
 * @param {string}   description      User-optional description
 *
 * @return
 *
 * @example
 */
export const registerCloudIntegrationAWS = (entityId,description = null, awsRoleArnString) => {
    // const awsRoleArnString = "arn:aws:iam::210866586737:role/BreachBits" //get this string from John its special for us

    return registerCloudIntegration(
        entityId,
        2, //typeId
        description,
        awsRoleArnString
    );
};

/**
 * Summary. unregisterCloudIntegration
 *
 * Description. Removes the cloud integration for the given integration Id
 *
 * @param {string}   integrationId      The id of the integration record.
 * @param {string}   details            Optional user-provided reason to remove integration.
 *
 * @return
 *
 * @example
 */
export const unregisterCloudIntegration = (integrationId, details = null) => {
    return {
        type: CLOUD_INTEGRATION_UNREGISTER,
        payload: {
            integrationId,
            details
        }
    };
};

export const unregisterCloudIntegrationSuccess = (data) => {
    return {
        type: CLOUD_INTEGRATION_UNREGISTER_SUCCESS,
        payload: data
    };
};

export const unregisterCloudIntegrationFail = (data) => {
    return {
        type: CLOUD_INTEGRATION_UNREGISTER_FAIL,
        payload: data
    };
};
/* ****************
Fetching cloud integration data for registered integrations
 *******************/
/**
 *
 * @param entityId
 * @param integrationId
 * @param queryType
 * @returns {{payload: {integrationId, entityId, queryType}, type: string}}
 */
export const fetchCloudIntegrationData = (entityId, integrationId, queryType, integrationDescription) => {

    return {
        type: FETCH_CLOUD_INTEGRATION_DATA,
        payload: {
            entityId,
            integrationId,
            queryType,
            integrationDescription,
        }
    };
};

export const fetchCloudIntegrationDataSuccess = (data) => {
    return {
        type: FETCH_CLOUD_INTEGRATION_DATA_SUCCESS,
        payload: data
    };
};

export const fetchCloudIntegrationDataFail = (data) => {
    return {
        type: FETCH_CLOUD_INTEGRATION_DATA_FAIL,
        payload: data
    };
};

/* ****************
Individual actions for cloud integration data calls
 *******************/

export const fetchCloudIntegrationAppsData = (entityId, integrationId) =>{
    return (fetchCloudIntegrationData(entityId, integrationId, "apps"))
}

export const fetchCloudIntegrationDatabasesData = (entityId, integrationId) =>{
    return (fetchCloudIntegrationData(entityId, integrationId, "databases"))
}

export const fetchCloudIntegrationStorageData = (entityId, integrationId) =>{
    return (fetchCloudIntegrationData(entityId, integrationId, "storage"))
}

export const fetchCloudIntegrationComputeData = (entityId, integrationId) =>{
    return (fetchCloudIntegrationData(entityId, integrationId, "compute"))
}

/* ****************
Get array of files associated with storage buckets in cloud integrations
 *******************/

// export const fetchCIStorageFiles = (entityId, integrationId, storageName) =>{
//     return (fetchCloudIntegrationData(entityId, integrationId, "files", storageName))
// }

/* ****************
Fetching cloud integration files, because they data comes back differnt, gonna handle it different
 *******************/
/**
 *
 * @param entityId
 * @param integrationId
 * @param queryType
 * @returns {{payload: {integrationId, entityId, queryType}, type: string}}
 */
export const fetchCloudIntegrationFiles = (entityId, integrationId, storageName,) => {

    return {
        type: FETCH_CLOUD_INTEGRATION_FILES,
        payload: {
            entityId,
            integrationId,
            storageName,
        }
    };
};

export const fetchCloudIntegrationFilesSuccess = (data) => {
    return {
        type: FETCH_CLOUD_INTEGRATION_FILES_SUCCESS,
        payload: data
    };
};

export const fetchCloudIntegrationFilesFail = (data) => {
    return {
        type: FETCH_CLOUD_INTEGRATION_FILES_FAIL,
        payload: data
    };
};

/* ****************
Fetching risk cycle social information
 *******************/
const fetchCycleSocial = (data) => {
    return {
        type: FETCH_CYCLE_SOCIAL,
        payload: data
    };
};

export const fetchCycleSocialSuccess = (data) => {
    return {
        type: FETCH_CYCLE_SOCIAL_SUCCESS,
        payload: data
    };
};

export const fetchCycleSocialFail = (data) => {
    return {
        type: FETCH_CYCLE_SOCIAL_FAIL,
        payload: data
    };
};

/* ****************
Risk Cycle Details helper: requesting by page
 *******************/

/**
 * Summary. fetchCycleSocialPagewise.
 *
 * Description. fetches a  cycle social information for the given page
 *
 *  @param {number}   cycleId             The Id of the cycle for which social is needed
 *   @param {number}   customerId             The Id of the entity
 *   @param {string}    entityId        the id of the entity
 * @param {number}   pageNum             The page number to fetch.
 *
 * @return
 *
 * @example
 */
export const fetchCycleSocialPagewise = (cycleId, customerId, entityId, pageNum= 1, ) => {

    const payload = {
        cycleId,
        customerId,
        entityId,
        pageNum,
    };

    return fetchCycleSocial(payload);

};

/* ****************
Fetching target details
 *******************/
export const fetchIdentityDetails = (data) => {
    return {
        type: FETCH_IDENTITY_DETAILS,
        payload: data
    };
};

export const fetchIdentityDetailsSuccess = (data) => {
    return {
        type: FETCH_IDENTITY_DETAILS_SUCCESS,
        payload: data
    };
};

export const fetchIdentityDetailsFail = (data) => {
    return {
        type: FETCH_IDENTITY_DETAILS_FAIL,
        payload: data
    };
};

/* ****************sarahp032022
Updating social tests authorized status for BR Business. Enables or disables social testing methods.
 *******************/
export const updateBRSocialTestsAuthorized = (data) => {
    return {
        type: UPDATE_BR_SOCIAL_TESTS_AUTHORIZED,
        payload: data
    };
};

export const disableBRSocialTestsAuthorized = (data) => {
    return {
        type: UPDATE_BR_SOCIAL_TESTS_AUTHORIZED,
        payload: {
            ...data,
            newAuthorizeStatus: false
        }
    };
};

export const enableBRSocialTestsAuthorized = (data) => {
    return {
        type: UPDATE_BR_SOCIAL_TESTS_AUTHORIZED,
        payload: {
            ...data,
            newAuthorizeStatus: true
        }
    };
};

export const updateBRSocialTestsAuthorizedSuccess = (data) => {
    return {
        type: UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_SUCCESS,
        payload: data
    };
};

export const updateBRSocialTestsAuthorizedFail = (data) => {
    return {
        type: UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_FAIL,
        payload: data
    };
};

/*  jfd**********22.March.24.03:50*****
 *   BREACHRISK TAGS-- Social Identities
     ********************** `--===<>==<>==C>-< */

//For social page updating scope, comments, issue status, etc
const addTagIdentitySuccess = (data) => {
    return {
        type: ADD_TAG_IDENTITY_SUCCESS,
        payload: data
    };
};

const addTagIdentityFail = (data) => {
    return {
        type: ADD_TAG_IDENTITY_FAIL,
        payload: data
    };
};

const updateTagIdentitySuccess = (data) => {
    return {
        type: UPDATE_TAG_IDENTITY_SUCCESS,
        payload: data
    };
};

const updateTagIdentityFail = (data) => {
    return {
        type: UPDATE_TAG_IDENTITY_FAIL,
        payload: data
    };
};

/* ****************
Tag helper Identities: Set Social Identity out of Scope
 *******************/
/**
 * Summary. tagIdentityOutOfScope.
 *
 * Description. Adds an 'Out of Scope' tag to the given social identity.
 *
 * @param {string}   customerId             The Id of the customer associated with the entity
 *  @param {string}   entityId             The Id of the entity
 * @param {string}   identityId             The Id of the identity to be tagged (same as tested_identity)
 *
 * @return
 *
 * @example
 */
export const tagIdentityOutOfScope = ( customerId, entityId, identityId,) => {
    //for Out Of Scope type, the definitionId is 38 as of Nov 2021
    console.log("tagIdentityOutOfScope data looks like", entityId, identityId, customerId )
    return addTag(
        addTagIdentitySuccess, //successAction
        addTagIdentityFail, //failAction
        38, //definitionId
        entityId, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        identityId, //identityId
        null, //details
        null, //userId
        customerId, //customerId
        null, //subportfolioId
        true, //showUserMessage
        identityId, //affectedElementId
    );
};

/* ****************
Tag helper: Set a social identity back in scope
 *******************/
/**
 * Summary. tagIdentityInScope.
 *
 * Description. Sets a social identity back in scope by removing the Out of Scope.
 *
 *  @param {number}   customerId             The Id of the customer
 *  @param {number}   identityId             The Id of the identity to be tagged (same as the tested_identity)
 * @param {object}   tag             The tag that should be set to inactive.
 *
 * @return
 *
 * @example
 */
export const tagIdentityInScope = (customerId, identityId, tag) => {
    //TODO: consider looking for any tag that is set to active that is on this vector.

    console.log("Helper function about to tagIdentityInScope", customerId, identityId, tag);

    if(bbIsObject(tag) && tag.definition.id === 38) {
        //TODO: verify that the tag is of type 38
        //for Out Of Scope type, the definitionId is 38 as of Nov 2021
        return updateTag(
            updateTagIdentitySuccess,
            updateTagIdentityFail,
            tag.id,
            false,
            customerId,
            identityId);
    } else {
        return updateTagIdentityFail({
            customerId,
            identityId,
            tagId: tag.id
        })
    }
};

/*  sarahp**********22.Aug.17.09:50*****
*   BREACHRISK TAGS-- Entity
********************** `--===<>==<>==C>-< */

//For adding and updating tags associtaed with an entity object, entity types, onboarding progress, etc
const addTagEntitySuccess = (data) => {
    return {
        type: ADD_TAG_ENTITY_SUCCESS,
        payload: data
    };
};

const addTagEntityFail = (data) => {
    return {
        type: ADD_TAG_ENTITY_FAIL,
        payload: data
    };
};

const updateTagEntitySuccess = (data) => {
    return {
        type: UPDATE_TAG_ENTITY_SUCCESS,
        payload: data
    };
};

const updateTagEntityFail = (data) => {
    return {
        type: UPDATE_TAG_ENTITY_FAIL,
        payload: data
    };
};

/* ****************
Tag helper: Set a "Getting Started Checklist"/Onboarding Progress Item as "Not Applicable"
 IPS NOT APPLICABLE
 *******************/

/**
 *
 * @param customerId
 * @param entityId
 * @returns {type}
 */
export const addTagAddIpsNotApplicable = ( customerId, entityId ,) => {
    console.log("addTagForOnboardingProgress data looks like", entityId, customerId )
    //ips not applicable tags are 71
    return addTag(
        addTagEntitySuccess, //successAction
        addTagEntityFail, //failAction
        71, //definitionId
        entityId, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityId
        null, //details
        null, //userId
        customerId, //customerId
        null, //subportfolioId
         true, //showUserMessage
        entityId, //affectedElementId
    );
};

export const updateTagAddIpsNotApplicable = (customerId, entityId, tag) => {
    console.log("Helper function about to updateTagForOnboardingProgress", customerId, entityId, tag);

    if(bbIsObject(tag) && tag.definition.id === 71) {
        //ips not applicable tags are 71
        return updateTag(
            updateTagEntitySuccess,
            updateTagEntityFail,
            tag.id,
            false,
            customerId,
            entityId);
    } else {
        return updateTagEntityFail({
            customerId,
            entityId,
            tagId: tag.id
        })
    }
};

/* ****************
Tag helper: Set a "Getting Started Checklist"/Onboarding Progress Item as "Not Applicable"
 ADDING DOMAINS NOT APPLICABLE
 *******************/


export const addTagAddDomainsNotApplicable = ( customerId, entityId ,) => {
    console.log("addTagDomainNA data looks like", entityId, customerId )
    //domains not applicable tags are 72
    return addTag(
        addTagEntitySuccess, //successAction
        addTagEntityFail, //failAction
        72, //definitionId
        entityId, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityId
        null, //details
        null, //userId
        customerId, //customerId
        null, //subportfolioId
        true, //showUserMessage
        entityId, //affectedElementId
    );
};

export const updateTagAddDomainsNotApplicable = (customerId, entityId, tag) => {
    console.log("Helper function about to updateTagAddDomainsNA", customerId, entityId, tag);
    //domains not applicable tags are 72
    if(bbIsObject(tag) && tag.definition.id === 72) {
        //ips not applicable tags are 72
        return updateTag(
            updateTagEntitySuccess,
            updateTagEntityFail,
            tag.id,
            false,
            customerId,
            entityId);
    } else {
        return updateTagEntityFail({
            customerId,
            entityId,
            tagId: tag.id
        })
    }
};

/* ****************
Tag helper: Set a "Getting Started Checklist"/Onboarding Progress Item as "Not Applicable"
 ADDING Cloud integrations NOT APPLICABLE
 *******************/


export const addTagCloudIntegrationNotApplicable = ( customerId, entityId ,) => {
    console.log("addTagCLoudIntegrationNA data looks like", entityId, customerId )
    //domains not applicable tags are 73
    return addTag(
        addTagEntitySuccess, //successAction
        addTagEntityFail, //failAction
        73, //definitionId
        entityId, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityId
        null, //details
        null, //userId
        customerId, //customerId
        null, //subportfolioId
        true, //showUserMessage
        entityId, //affectedElementId
    );
};

export const updateTagCloudIntegrationNotApplicable = (customerId, entityId, tag) => {
    console.log("Helper function about to updateTagCloudIntegrationNA", customerId, entityId, tag);
    //domains not applicable tags are 73
    if(bbIsObject(tag) && tag.definition.id === 73) {
        //ips not applicable tags are 73
        return updateTag(
            updateTagEntitySuccess,
            updateTagEntityFail,
            tag.id,
            false,
            customerId,
            entityId);
    } else {
        return updateTagEntityFail({
            customerId,
            entityId,
            tagId: tag.id
        })
    }
};

/* ****************
Tag helper: Set a "Getting Started Checklist"/Onboarding Progress Item as "Not Applicable"
 ADDING Identities NOT APPLICABLE
 *******************/


export const addTagAddIdentitiesNotApplicable = ( customerId, entityId ,) => {
    console.log("addTagAddIdentitiesNA data looks like", entityId, customerId )
    //domains not applicable tags are 74
    return addTag(
        addTagEntitySuccess, //successAction
        addTagEntityFail, //failAction
        74, //definitionId
        entityId, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityId
        null, //details
        null, //userId
        customerId, //customerId
        null, //subportfolioId
        true, //showUserMessage
        entityId, //affectedElementId
    );
};

export const updateTagAddIdentitiesNotApplicable = (customerId, entityId, tag) => {
    console.log("Helper function about to updateTagAddIdentitiesNA", customerId, entityId, tag);
    //domains not applicable tags are 74
    if(bbIsObject(tag) && tag.definition.id === 74) {
        //ips not applicable tags are 74
        return updateTag(
            updateTagEntitySuccess,
            updateTagEntityFail,
            tag.id,
            false,
            customerId,
            entityId);
    } else {
        return updateTagEntityFail({
            customerId,
            entityId,
            tagId: tag.id
        })
    }
};


/*  sarahp**********25.SEP.22*****
  setting internal state flag to trigger reload of entity when onboarding progress item is completed
     **********************  */
//currently just using didjustaddnewentity tag and having the fetch portfolio set back to false

// export const setUpdateEntityOnboardingProgress = (data) => {
//     return{
//         type: SET_UPDATE_ENTITY_ONBOARDING_PROGRESS,
//         payload: data
//     }
// }
//
// export const unsetUpdateEntityOnboardingProgress = (data) => {
//     return{
//         type: UNSET_UPDATE_ENTITY_ONBAORDING_PROGRESS,
//         payload: data
//     }
// }


/*  sarahp**********17.NOV.22*****
  fetching testing results for individual threat vector
     **********************  */
/**
 *
 * @param entityId
 * @param customerId
 * @param cycleId
 * @param vectorId
 * @returns {{payload: {customerId, cycleId, vectorId, entityId}, type: string}}
 */
export const fetchVectorResults = (entityId, customerId ,cycleId,vectorId)=>{

    return{
        type: FETCH_VECTOR_RESULTS,
        payload: {
            entityId,
            customerId,
            cycleId,
            vectorId,
        },
    }
}

export const fetchVectorResultsSuccess = (data)=>{
    return{
        type:FETCH_VECTOR_RESULTS_SUCCESS,
        payload: data,
    }
}

export const fetchVectorResultsFail = (data)=>{
    return{
        type:FETCH_VECTOR_RESULTS_FAIL,
        payload: data,
    }
}

/*  jfd**********22.Nov.28.13:26*****
 *   SUBPORTFOLIO ACTIONS.
 *   Actions for creation, editing, deletion of subportfolio
 *   Actions for how entities are added, moved within subportfolio/portfolio groups
     ********************** `--===<>==<>==C>-< */

/* ****************
Adding a new subportfolio
 *******************/
/**
 * Summary. addSubportfolio
 *
 * Description. Adds a new subportfolio to the customer's database. Subportfolios allow entities within the master portfolio to be grouped.
 *
 *  @param {string}   customerId             The Id of the customer for the new subportfolio
 *   @param {string}   name             The desired name of the new subportfolio
 *   @param {string}    description        The desired description of the new subportfolio
 *
 * @return
 *
 * @example
 */
export const addSubportfolio = (customerId, name, description) => {
    return {
        type: ADD_BR_SUBPORTFOLIO,
        payload: {
            customerId: customerId,
            name: name,
            description: description
        },
    };
};

export const addSubportfolioSuccess = (data) => {
    return {
        type: ADD_BR_SUBPORTFOLIO_SUCCESS,
        payload: data
    };
};

export const addSubportfolioFail = (data) => {
    return {
        type: ADD_BR_SUBPORTFOLIO_FAIL,
        payload: data
    };
};

/* ****************
Modifying a  subportfolio
 *******************/
/**
 * Summary. updateSubportfolio
 *
 * Description. Edit a subportfolio.
 *
 *  @param {string}   subportfolioId             The Id of the subportfolio to edit
 *   @param {string}   name             The updated name of the new subportfolio
 *   @param {string}    description        The updated description of the new subportfolio
 *
 * @return
 *
 * @example
 */
export const updateSubportfolio = (subportfolioId, name = null, description = null) => {
    return {
        type: UPDATE_BR_SUBPORTFOLIO,
        payload: {
            subportfolioId,
            name,
            description,
        },
    };
};

export const updateSubportfolioSuccess = (data) => {
    return {
        type: UPDATE_BR_SUBPORTFOLIO_SUCCESS,
        payload: data
    };
};

export const updateSubportfolioFail = (data) => {
    return {
        type: UPDATE_BR_SUBPORTFOLIO_FAIL,
        payload: data
    };
};

/* ****************
Deleting a new subportfolio
 *******************/
/**
 * Summary. deleteSubportfolio
 *
 * Description. Deactivates a  subportfolio for the giv
 *
 *  @param {string}   customerId             The Id of the customer for the new subportfolio
 *   @param {string}   subportfolioId             Id of the subportfolio to delete
 *
 * @return
 *
 * @example
 */
export const deleteSubportfolio = (customerId, subportfolioId) => {
    //TODO: consider making it so that this action doesn't reload all of the portfolios???
    return {
        type: DELETE_BR_SUBPORTFOLIO,
        payload: {
            customerId,
            subportfolioId
        },
    };
};

export const deleteSubportfolioSuccess = (data) => {
    return {
        type: DELETE_BR_SUBPORTFOLIO_SUCCESS,
        payload: data
    };
};

export const deleteSubportfolioFail = (data) => {
    return {
        type: DELETE_BR_SUBPORTFOLIO_FAIL,
        payload: data
    };
};

/* ****************
Adding a new entity to a subportfolio at the time you make the entity
 *******************/
/**
 * Summary. addBRPortfolioEntityAndAddToSubportfolio
 *
 * Description. Creates a new entity for a portfolio, and immediately adds it to the given subportfolio
 *
 *  @param {string}   customerId             The Id of the customer for the new subportfolio
 *  @param {string}   newEntityName          Name of the new entity the user is creating
 *  @param {string}   newEntityWebsite       Website url of the new entity the user is creating
 *  @param {string}   subportfolioId         Id of the subportfolio
 *
 * @return
 *
 * @example
 */
export const addBRPortfolioEntityAndAddToSubportfolio = (customerId, newEntityName, newEntityWebsite, subportfolioId) => {
    return {
        type: ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO,
        payload: {
            customerId,
            newEntityName,
            newEntityWebsite,
            subportfolioId
        },
    };
};

export const addBRPortfolioEntityAndAddToSubportfolioSuccess = (data) => {
    return {
        type: ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO_SUCCESS,
        payload: data
    };
};

export const addBRPortfolioEntityAndAddToSubportfolioFail = (data) => {
    return {
        type: ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO_FAIL,
        payload: data
    };
};

/* ****************
Adding an already existing entity to a subportfolio at the time you make the entity
 *******************/
/**
 * Summary. addExistingEntityToSubportfolio
 *
 * Description. Adds an existing entity to the given subportfolio
 *
 * @param {string}   customerId              The customerId to add to allow updating local state
 *  @param {string}   entityId             The Id of the entity to add to a subportfolio
 *  @param {string}   subportfolioId          Id of the subportfolio
 *
 * @return
 *
 * @example
 */
export const addExistingEntityToSubportfolio = (customerId, entityId, subportfolioId) => {
    //jfd: Definition is 55 for associating subportfolios with entities as of Nov 2022. and entityId is supposed to be passed via the details param
    return addTag(
        addExistingEntityToSubportfolioSuccess, //successAction
        addExistingEntityToSubportfolioFail, //failAction
        55, //definitionId
        null, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityId
        entityId, //details
        null, //userId
        customerId, //customerId
        subportfolioId, //subportfolioId
        true, //showUserMessage
        subportfolioId, //affectedElementId
    );
};

export const addExistingEntityToSubportfolioSuccess = (data) => {
    //TODO: Make the success reducer update the local state.
    return {
        type: ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO_SUCCESS,
        payload: data
    };
};

export const addExistingEntityToSubportfolioFail = (data) => {
    return {
        type: ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO_FAIL,
        payload: data
    };
};

/* ****************
Removing an entity from a subportfolio but not the master portfolio
 *******************/
/**
 * Summary. removeEntityFromSubportfolio
 *
 * Description. Removes a given entity from a subportfolio by deactivating a provided tagId
 *
 *  @param {string}   customerId              The customerId to remove to allow updating local state
 *  @param {string}   entityId              The entityId to remove
 *  @param {object}   subportfolioObject       The subportfolio that it will be removed from
 *
 * @return
 *
 * @example
 */
export const removeEntityFromSubportfolio = (customerId, entityId, subportfolioObject) => {
    //look for the entityId within the portfolio
    //portfolio.entities is an array of objects Nov 2022
    //each object structure has {id : "", entity: ""}
    //search the .entities structure for the id.
    //this also makes this function safer so it has more assurance it is removing a tagId that is actually in the portfolio object,
    //not just an arbitrary tagId

    //initial checks
    if(
        entityId
        && customerId
        && subportfolioObject
        && bbIsObject(subportfolioObject)
        && subportfolioObject.entities
        && Array.isArray(subportfolioObject.entities)
        && subportfolioObject.entities.length > 0
    ){
        const foundEntity = subportfolioObject.entities.find(e => e.entity === entityId);

        if(foundEntity){

            const associatedTagId = foundEntity.id;

            console.log("removeEntityFromSubportfolio attempting to remove entity ", entityId, "from subportfolio ", subportfolioObject, "by disabling tag ", associatedTagId);

            return updateTag(
                removeEntityFromSubportfolioSuccess,
                removeEntityFromSubportfolioFail,
                associatedTagId,
                false,
                customerId,
                subportfolioObject.id, //affectedElementId
            );

        } else {
            console.warn("removeEntityFromSubportfolio passes initial checks but the requested entityId cannot be found", "entityId", entityId, "subportfolioObject", subportfolioObject, "subportfolioObject.entities", subportfolioObject.entities, "is array", Array.isArray(subportfolioObject.entities), "foundEntity", foundEntity);
            return removeEntityFromSubportfolioFail({
                entityId,
                subportfolioObject
            })
        }

    } else {
        console.warn("removeEntityFromSubportfolio failed initial checks", "entityId", entityId, "subportfolioObject", subportfolioObject);

        return removeEntityFromSubportfolioFail({
            entityId,
            subportfolioObject
        })
    }
};

export const removeEntityFromSubportfolioSuccess = (data) => {
    //TODO: make the reducer update the local state
    return {
        type: DELETE_BR_ENTITY_FROM_SUBPORTFOLIO_SUCCESS,
        payload: data
    };
};

/**
 *
 * @param data
 * @returns {{payload, type: string}}
 */
export const removeEntityFromSubportfolioFail = (data) => {
    return {
        type: DELETE_BR_ENTITY_FROM_SUBPORTFOLIO_FAIL,
        payload: data
    };
};

/* ****************
Update an entity name from within a portfolio (admin only call)
 *******************/

export const updateEntityNameInPortfolio = (customerId, entityId, updatedName) => {
    return {
        type: UPDATE_ENTITY_NAME,
        payload: {
            customerId,
            entityId,
            updatedName
        },
    };
};
export const updateEntityNameSuccess = (data) => {
    return {
        type: UPDATE_ENTITY_NAME_SUCCESS,
        payload: data,
    };
};
export const updateEntityNameFail = (data) => {
    return {
        type: UPDATE_ENTITY_NAME_FAIL,
        payload: data,
    };
};



